import { render } from "./EmployeeChangeRecordAdd.vue?vue&type=template&id=cf80a93c&scoped=true"
import script from "./EmployeeChangeRecordAdd.vue?vue&type=script&lang=js"
export * from "./EmployeeChangeRecordAdd.vue?vue&type=script&lang=js"

import "./EmployeeChangeRecordAdd.vue?vue&type=style&index=0&id=cf80a93c&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf80a93c"]])

export default __exports__